import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pa-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_members_show_edit_member_personal_info = _resolveComponent("members-show-edit-member-personal-info")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_members_show_member_organization_info = _resolveComponent("members-show-member-organization-info")!
  const _component_members_show_member_accesses_list = _resolveComponent("members-show-member-accesses-list")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_tabs, {
      modelValue: _ctx.tab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
      "indicator-color": "primary",
      align: "left",
      "narrow-indicator": "",
      class: "bg-grey-3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_tab, {
          name: "personal_info",
          label: "Member personal information"
        }),
        (_ctx.isMemberWithOrganization)
          ? (_openBlock(), _createBlock(_component_q_tab, {
              key: 0,
              name: "organization_info",
              label: "Member organization information"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_q_tab, {
          name: "accesses_info",
          label: "Member accesses"
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_tab_panels, {
      modelValue: _ctx.tab,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tab) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_tab_panel, {
          name: "personal_info",
          class: "q-pt-md q-px-none"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_members_show_edit_member_personal_info, {
              "is-member-in-organization": _ctx.isMemberWithOrganization,
              "onUpdate:is-member-in-organization": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isMemberWithOrganization) = $event)),
              member: _ctx.memberModel
            }, null, 8, ["is-member-in-organization", "member"])
          ]),
          _: 1
        }),
        (_ctx.isMemberWithOrganization)
          ? (_openBlock(), _createBlock(_component_q_tab_panel, {
              key: 0,
              name: "organization_info",
              class: "q-pt-md q-px-none"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_members_show_member_organization_info, { member: _ctx.memberModel }, null, 8, ["member"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_q_tab_panel, {
          name: "accesses_info",
          class: "q-pt-md q-px-none"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_members_show_member_accesses_list)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_btn, {
      label: "Back to listing",
      to: _ctx.membersListRoute,
      color: "primary",
      outline: "",
      "no-caps": ""
    }, null, 8, ["to"]),
    _createVNode(_component_q_btn, {
      label: "Delete member",
      onClick: _cache[3] || (_cache[3] = () => _ctx.onDeleteMember(_ctx.memberModel)),
      color: "red-8",
      class: "q-ml-md",
      outline: ""
    })
  ]))
}